const featureItems = [
  {
    icon: 'ri-search-eye-line',
    title: '多维度交叉验证',
    desc: '每篇专题均基于公开报道、官方通报、当事人声明等多方信息源综合整理，拒绝单一信源，确保信息全面可靠。',
  },
  {
    icon: 'ri-book-open-line',
    title: '百科式知识盘点',
    desc: '以结构化方式呈现事件背景、人物关系、时间线和各方回应，帮助读者建立对事件的完整认知框架。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '严格内容审核',
    desc: '编辑团队对每条信息进行溯源核实，未经证实的内容明确标注"待核实"，坚持对读者负责的编辑原则。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            为什么选择黑料入口了解事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}